/* istanbul ignore file */
import { Box, Image, Dialog } from '@packages/shared';
import { useState } from 'react';

export type LegacyEnergyFlagProps = {
  icon: string;
  overlayImg: string;
  overlayTitle?: string;
};

// TODO(api-layer): remove unnecessary component after resolver implemented
export const LegacyEnergyFlag = ({
  icon,
  overlayImg,
  overlayTitle = '',
}: LegacyEnergyFlagProps) => {
  const [overlay, setOverlay] = useState(false);

  const overlayContent =
    overlay && overlayImg.length ? (
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: 600,
          '> img': {
            objectFit: 'contain',
          },
        }}
      >
        <Image src={overlayImg} alt={overlayTitle} fill />
      </Box>
    ) : null;

  return (
    <>
      {overlay && (
        <Dialog
          open={overlay}
          handleClose={() => setOverlay(false)}
          title={overlayTitle}
          dialogContent={overlayContent}
        />
      )}
      <Image
        src={icon}
        width={35}
        height={20}
        alt={overlayTitle}
        onClick={() => setOverlay(true)}
        style={{ cursor: 'pointer' }}
      />
    </>
  );
};
